import Axios from 'axios';
import { getClientRut, campaignProviderUrl } from '../service.parameters';
import { SERVICECONFIG, buildURL } from '../mopa.services.definitions';

/**
 *
 * @param {String} rut rut with verifier digit (ex 1234567-1)
 */
export const mopaFormatRut = rut => rut.replace('-', '').padStart(10, '0');

const axios = Axios.create({
  timeout: 30000
});

const getSignature = async () => {
  const _session = sessionStorage.getItem('_session');
  if (_session) {
    return JSON.parse(_session)
  } else {
    const {
      data: {
        SESSION: { signature }
      }
    } = await axios.get(buildURL(SERVICECONFIG.SIGNATURE));
    sessionStorage.setItem('_session', signature);
    return signature;
  }
};
export const getCustomerCampaignTemplate = async () => {
  const signature = await getSignature();
  const {
    data: { lstCstCampanasSec }
  } = await axios.get(
    buildURL(
      {
        ...SERVICECONFIG.CAMPAIGN,
        ...{
          nrut: mopaFormatRut(await getClientRut()),
          signature
        }
      },
      {
        campaignProviderUrl: await campaignProviderUrl(),
        ajaxType: 'emulaajax',
        noTransacPath: true
      }
    )
  );
  return lstCstCampanasSec;
};

export const getCustomerCampaignDetailsTemplate = async idCampaign => {
  const signature = await getSignature();
  const {
    data: { lstCstCampanas }
  } = await axios.get(
    buildURL(
      {
        ...SERVICECONFIG.CAMPAIGNDETAILS,
        ...{
          nrut: mopaFormatRut(await getClientRut()),
          canal: 1,
          idmensajefiltro: idCampaign,
          signature
        }
      },
      {
        campaignProviderUrl: await campaignProviderUrl(),
        ajaxType: 'emulaajax',
        noTransacPath: true
      }
    )
  );
  return lstCstCampanas;
};

export const getDefaultCustomerCampaign = async () => {
  const { data } = await axios.get('/scotiaweb/html/blanco_posicion.2.html', {
    headers: {
      Accept: 'text/html'
    }
  });
  return data;
};

export const getDefaultCustomerCampaignDetails = async () => {
  const { data } = await axios.get(
    '/scotiaweb/html/det_blanco_posicion.2.html',
    {
      headers: {
        Accept: 'text/html'
      }
    }
  );
  return data;
};
